import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordPill } from '@zola-helpers/client/dist/es/marketplace/vendorWords';

import cx from 'classnames';

import { getVendorIconV2 } from '~/util/vendorUtils';

import styles from './vendorIcon.module.less';

type VendorIconProps = {
  vendorTaxonomyKey: VendorTaxonomyKey;
  size?: number;
} & React.HTMLAttributes<HTMLDivElement>;

const VendorIcon = (props: VendorIconProps) => {
  const { vendorTaxonomyKey, size = 64, className, style, ...rest } = props;
  const icon = getVendorIconV2(vendorTaxonomyKey);
  const name = getVendorWordPill(vendorTaxonomyKey);
  const appliedStyle = {
    width: size,
    height: size,
    ...style,
  };
  return (
    <div className={cx(styles.icon, className)} style={appliedStyle} {...rest}>
      <img src={icon} alt={name} />
    </div>
  );
};

export default VendorIcon;
